var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.746 1.464l3.11 6.3 6.954 1.012a.83.83 0 01.461 1.418l-5.033 4.9 1.188 6.926a.832.832 0 01-1.207.877L12 19.632 5.78 22.9a.833.833 0 01-1.207-.878L5.761 15.1.728 10.2a.83.83 0 01.461-1.418l6.954-1.017 3.11-6.3a.833.833 0 011.493-.001z",
    fill: "#F6C300"
  })));
}

export default SvgStar;